import React, { useState } from "react";
import Navbar from "../Navbar";
import { Box, Button, Grid, Stack, TextField, Typography } from "@mui/material";
import styles from "./Service.module.scss";
import { useFormik } from "formik";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import opdConsultations from ".././../images/doctor-consultation 1.svg";
import healthCareShield from ".././../images/shield 1.svg";
import healthCheckup from ".././../images/woman 1.svg";
import * as yup from "yup";
import Footer from "../Footer";
import { checkPlanPricing } from "../../services/Contact";
import { toast } from "react-toastify";

const OurServices = () => {
  const schema = yup
    .object({
      age: yup.string().required("Age is required"),

      mobileNumber: yup
        .string()
        .matches(/^[6-9]\d{9}$/, "Enter a valid 10-digit mobile number")
        .required("Mobile number is required"),

      pincode: yup
        .string()
        .matches(/^[1-9][0-9]{5}$/, "Enter a valid 6-digit pincode")
        .required("Pincode is required"),
    })
    .required();

  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    return Array.from(
      { length: 5 },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join("");
  };

  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);

  const onSubmit = async (values, actions) => {
    console.log(values);
    try {
      const res = await checkPlanPricing(values);
      if (res) {
        resetForm();
        setCaptcha(generateCaptcha());
        setCaptchaInput("");
        setIsCaptchaValid(false);
        toast.success("Successfully submitted");
      }
    } catch (error) {
      console.error(error.message);
    }
  };
  const {
    values,
    touched,
    errors,
    handleSubmit,
    handleBlur,
    handleChange,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: {
      age: "",
      mobileNumber: "",
      pincode: "",
    },
    validationSchema: schema,
    onSubmit,
  });

  const handleCaptchaChange = (e) => {
    const input = e.target.value.toUpperCase();
    setCaptchaInput(input);
    setIsCaptchaValid(input === captcha);
  };
  return (
    <div className={styles.OurServicesMainDiv}>
      <Navbar />
      <Box className={styles.mainBody}>
        <Typography variant="h5">Our Services</Typography>

        <div className={styles.descriptionBox}>
          <Typography variant="h4" className={styles.heading}>
            Affordable, Accessible Healthcare for You and Your Family
          </Typography>

          <Typography variant="body1" className={styles.description}>
            High OPD expenses remain a major healthcare pain point in India,
            with OPD treatments rarely covered by insurance, causing financial
            stress. Tron Healthcare solves this by offering discounts for OPD
            consultations, tests, and outpatient specialist care through
            affordable membership plans. Our network provides OPD insurance-like
            benefits without claim hassles – saving families 20-40% on routine
            healthcare costs.
          </Typography>

          <Typography variant="body1" className={styles.description}>
            The Tron membership plans provide exclusive discounts on
            consultations, diagnostic tests, and OPD procedures across our
            network of trusted healthcare providers. These OPD discount plans
            also provide access to preventive health checkups with at-home
            sample collection at unbeatable prices.
          </Typography>
        </div>

        <div className={styles.tronOpdPlansSection}>
          <Box className={styles.leftSide}>
            <Typography variant="h3">
              Tron OPD Plans <br />
              Starting at Rs 1/day
            </Typography>
            <Box className={styles.planDetails}>
              <Stack direction="row" className={styles.individual} spacing={2}>
                <PersonIcon className={styles.personIcon} />
                <div>
                  <Typography varient="h6" className={styles.heading}>
                    Individual Plan
                  </Typography>
                  <Typography className={styles.content}>
                    Coverage for one person
                  </Typography>
                </div>
              </Stack>
              <Stack direction="row" className={styles.family} spacing={2}>
                <GroupsIcon className={styles.groupIcon} />
                <div>
                  <Typography varient="h6" className={styles.heading}>
                    Family Plan
                  </Typography>
                  <Typography className={styles.content}>
                    Extend benefits to spouse, parents, or children 
                  </Typography>
                </div>
              </Stack>
            </Box>
            <Typography variant="h4">
              *Discount percentages vary based on plan purchased.
            </Typography>
          </Box>
          <Box className={styles.rightSide}>
            <Typography variant="h3">Get your Tron OPD Plan</Typography>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" className={styles.label}>
                    Age of the eldest member (self, spouse)
                  </Typography>
                  <TextField
                    fullWidth
                    name="age"
                    size="small"
                    value={values.age}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.age && Boolean(errors.age)}
                    helperText={touched.age && errors.age}
                    placeholder="Enter your age"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" className={styles.label}>
                    Mobile Number
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    name="mobileNumber"
                    value={values.mobileNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.mobileNumber && Boolean(errors.mobileNumber)}
                    helperText={touched.mobileNumber && errors.mobileNumber}
                    placeholder="Enter your mobile number"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" className={styles.label}>
                    Pincode
                  </Typography>
                  <TextField
                    fullWidth
                    name="pincode"
                    size="small"
                    value={values.pincode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.pincode && Boolean(errors.pincode)}
                    helperText={touched.pincode && errors.pincode}
                    placeholder="Enter your pincode"
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ mt: "5px" }}>
                <Grid item xs={12} sm={3}>
                  <Typography variant="body1" className={styles.label}>
                    Captcha
                  </Typography>
                  <Box
                    sx={{
                      background: "#f0f0f0",
                      padding: "8px 12px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      letterSpacing: "3px",
                      userSelect: "none",
                      width: "fit-content",
                      borderRadius: "4px",
                      mb: 1,
                    }}
                  >
                    {captcha}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter captcha"
                    value={captchaInput}
                    onChange={handleCaptchaChange}
                    error={captchaInput && !isCaptchaValid}
                    helperText={
                      captchaInput && !isCaptchaValid
                        ? "Captcha does not match"
                        : ""
                    }
                  />
                </Grid>
              </Grid>
              <Button
                type="submit"
                variant="contained"
                disabled={!isCaptchaValid}
                sx={{
                  backgroundColor: isCaptchaValid
                    ? "rgba(216, 63, 135, 1)"
                    : "#ccc",
                  textAlign: "left",
                  mt: "10px",
                  color: "#FFFFFF",
                  textTransform: "capitalize",
                  fontSize: "16px",
                  borderRadius: "3px",
                  // padding: "5px 10px",
                  "&:hover": {
                    backgroundColor: isCaptchaValid
                      ? "rgba(216, 63, 135, 1)!important"
                      : "#ccc",
                  },
                }}
                fullWidth
              >
                Submit
              </Button>
            </form>
          </Box>
        </div>

        <div className={styles.features}>
          <Typography variant="h5" className={styles.sectionTitle}>
            Plan Benefits & Features
          </Typography>
          <div className={styles.featureGrid}>
            <div className={styles.featureBox}>
              <img src={opdConsultations} alt="opdconsult" />
              <Typography variant="h6">Discounted OPD Consultations</Typography>
              <ul>
                <li>Ophthalmology (Eye Care)</li>
                <li>ENT (Ear, Nose & Throat)</li>
                <li>Dental</li>
                <li>Gastroenterology</li>
                <li>Gynecology</li>
              </ul>
            </div>
            <div className={styles.featureBox}>
              <img src={healthCheckup} alt="healthcheckup" />
              <Typography variant="h6">
                Comprehensive Preventive Health Check-ups
              </Typography>
              <ul>
                <li>Wide range of diagnostic tests available</li>
                <li>Free at-home sample collection service</li>
              </ul>
            </div>
            <div className={styles.featureBox}>
              <img src={healthCareShield} alt="healthShield" />
              <Typography variant="h6">
                Transparent Healthcare <br /> Access
              </Typography>
              <ul>
                <li>Clear pricing with no hidden costs</li>
                <li>Easy online booking for consultations and tests</li>
              </ul>
            </div>
          </div>
        </div>

        <div className={styles.whySection}>
          <div className={styles.whyGrid}>
            {/* Column 1: Heading */}
            <div className={styles.whyColumn}>
              <Typography variant="h5" className={styles.whyTitle}>
                Why Choose Tron OPD Plans?
              </Typography>
            </div>

            {/* Column 2: Two points + Button */}
            <div className={styles.whyColumn}>
              <div className={styles.iconItem}>
                <CheckCircleOutlineIcon className={styles.checkIcon} />
                <span>Save significantly on healthcare</span>
              </div>
              <div className={styles.iconItem}>
                <CheckCircleOutlineIcon className={styles.checkIcon} />
                <span>Access to quality doctors and services</span>
              </div>
              <Button variant="contained" className={styles.viewBtn}>
                View Membership Plans
              </Button>
            </div>

            {/* Column 3: Two more points */}
            <div className={styles.whyColumn}>
              <div className={styles.iconItem}>
                <CheckCircleOutlineIcon className={styles.checkIcon} />
                <span>Convenient at-home test collection</span>
              </div>
              <div className={styles.iconItem}>
                <CheckCircleOutlineIcon className={styles.checkIcon} />
                <span>Simple digital onboarding process</span>
              </div>
            </div>
          </div>
        </div>
      </Box>
      <Footer />
    </div>
  );
};

export default OurServices;
